import * as React from "react";
import BaseComponent from "../../utility/BaseComponent";
import { AsyncOperationsModel } from "../../utility/AsyncOperationsModel";
import { IAdminApi } from "../../utility/admin/AdminApi";
import { action, observable } from "mobx";
import { IRole, IGroup, IOrganisation, IUser, AccountStatus } from "../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { SelectField, Checkbox, DialogContainer, Card, CardText, CircularProgress } from "react-md";
import { observer } from "mobx-react";
import "./static/BulkEditUsers.scss";
import { IUsersOperations } from "../../utility/admin/UsersControls/UsersOperations/IUsersOperations";
export class BulkEditUsersModel extends AsyncOperationsModel {
    @observable roles: IRole[];
    @observable groups: IGroup[];
    @observable users: IUser[];
    @observable showDialog: boolean = false;
    @observable onEditCompleted: Function;

    @observable selectRoleEnabled: boolean = false;
    @observable selectGroupEnabled: boolean = false;
    @observable selectStatusEnabled: boolean = false;
    @observable selectedRole: IRole;
    @observable selectedGroup: IGroup;
    @observable selectedStatus: AccountStatus;
    private readonly adminApi: IAdminApi;
    private readonly operations: IUsersOperations;
    private readonly organisationCode: string;
    constructor(
        operations: IUsersOperations, 
        organisationCode: string, 
        onEditCompleted: Function) {
        super();
        this.operations = operations;
        this.adminApi = operations.getApi();
        this.organisationCode = organisationCode;
        this.onEditCompleted = onEditCompleted;
    }
    @action.bound
    onRoleSelected(roleId: string) {
        let roleIndex = this.roles.findIndex( item => item.id === roleId );
        if (roleIndex > -1) {
            this.selectedRole = this.roles[roleIndex];
        }
    }
    @action.bound
    onGroupSelected(groupId: string) {
        let groupIndex = this.groups.findIndex( item => item.id === groupId );
        if (groupIndex > -1) {
            this.selectedGroup = this.groups[groupIndex];
        }
    }
    @action.bound
    onStatusSelected(status: AccountStatus) {
        this.selectedStatus = status;
    }
    @action.bound
    setShowDialog(showDialog: boolean) {
        this.showDialog = showDialog;
    }
    @action.bound
    setUsers(users: IUser[]) {
        this.users = users;
    }
    @action.bound
    resetAsyncOperationsCount() {
        this.asyncOperationsCount = 0;
    }
    @action.bound
    setRoles(organisation: IOrganisation) {
        if (!isNullOrUndefined(organisation.roles)) {
            this.roles = organisation.roles;
        }
    }
    @action.bound
    setGroups(organisation: IOrganisation) {
        if (!isNullOrUndefined(organisation.groups)) {
            this.groups = organisation.groups;
        }
    }
    @action.bound
    prepare() {
        this.resetAsyncOperationsCount();
        this.adminApi.getOrganisationDetails(this.organisationCode)
        .first()
        .subscribe(
            result => {
                this.resetAsyncOperationsCount();
                this.setRoles(result);
                this.setGroups(result);
            },
            error => {
                this.resetAsyncOperationsCount();
                this.setErrorMessages(error.message);
            }
        );
    }
    @action.bound
    hideDialog() {
        this.onEditCompleted();
    }
    @action.bound
    executeOperations() {
        this.incrementAsyncOperations();
        this.users.forEach(
            user => {
                if (!isNullOrUndefined(this.selectedRole)) {
                    user.role = this.selectedRole;
                }
                if (!isNullOrUndefined(this.selectedGroup)) {
                    user.groups = [this.selectedGroup];
                }
                if (!isNullOrUndefined(this.selectedStatus)) {
                    user.status = this.selectedStatus;
                }

            }
        );
        // let requestItems = this.users.map(
        //     user => {
        //         let output: EditUserItem = {};
        //         output.user_id = user.id;
        //             output.new_role = this.selectedRole;
        //         }
        //             output.add_groups = [];
        //             output.remove_groups = [];
        //             output.add_groups.push(this.selectedGroup);
        //             if (!isNullOrUndefined(user.groups)) {
        //                 output.remove_groups = output.remove_groups.concat(user.groups);
        //             }
        //         }
        //             output.new_status = this.selectedStatus;
        //         }
        //         return output;
        //     }
        // );
        this.operations.editUsers(this.users)
        .first()
        .subscribe(
            result => {
                this.resetAsyncOperationsCount();
                this.onEditCompleted(result, result);
            },
            error => {
                this.resetAsyncOperationsCount();
                this.setErrorMessages([ error.message ]);
            }
        );
    }
} 
@observer class BulkEditUsers extends BaseComponent<{ model: BulkEditUsersModel }, {}> {

    render() {
        return (
            <DialogContainer
                
                dialogClassName="BulkEditUsersDialog"
                contentClassName="BulkEditUsersDialogContent"
                id="EditUsersDialog"
                visible={this.props.model.showDialog}
                title="Edit Users"
                modal={true}
                actions={[
                    {
                        onClick: this.props.model.executeOperations,
                        secondary: true,
                        children: "Apply"
                    },
                    {
                        onClick: this.props.model.hideDialog,
                        secondary: true,
                        children: "Cancel"
                    }
                ]}
            >
            {           this.props.model.asyncOperationsCount === 0 && 
                        this.props.model.errorMessages.length > 0 &&
                        <Card className="messagesCard">
                            <CardText className="messageText">
                                {
                                    this.props.model.errorMessages.map(
                                        (item, index) => {
                                            return <p key={index}>{item}</p>;
                                        }
                                    )
                                }
                            </CardText>
                        </Card>
                    }
            {
                this.props.model.asyncOperationsCount > 0 && 
                <CircularProgress id="progress" centered={true}/>
            }
            {
                this.props.model.asyncOperationsCount === 0 && 
                !isNullOrUndefined(this.props.model.roles) &&
                !isNullOrUndefined(this.props.model.groups) &&
                <div>
                    <div className='BulkEditUsersOptions'>
                        <Checkbox 
                            label="Change Role" 
                            id="enableRoleCheckBox" 
                            name="Chane Role" 
                            onChange={(checked: boolean) => this.props.model.selectRoleEnabled = checked}
                        />    
                        <SelectField
                            id="selectRoles"
                            menuItems={
                                this.props.model.roles.map(item => {
                                        return {label: item.name, value: item.id};
                                })
                            }
                            onChange={this.props.model.onRoleSelected}
                            placeholder="Select Role"
                            disabled={!this.props.model.selectRoleEnabled}
                        />
                    </div>
                    <div className='BulkEditUsersOptions'>
                        <Checkbox 
                            label="Change Group" 
                            id="enableGroupsCheckBox" 
                            name="Chane Group" 
                            onChange={(checked: boolean) => this.props.model.selectGroupEnabled = checked}
                        />    
                        <SelectField
                            id="selectGroup"
                            menuItems={
                                this.props.model.groups.map(item => {
                                        return {label: item.name, value: item.id};
                                })
                            }
                            onChange={this.props.model.onGroupSelected}
                            placeholder="Select Group"
                            disabled={!this.props.model.selectGroupEnabled}
                        />
                    </div>
                    <div className='BulkEditUsersOptions'>
                        <Checkbox 
                            label="Change Status" 
                            id="enableStatusCheckBox" 
                            name="Chane Role" 
                            onChange={(checked: boolean) => this.props.model.selectStatusEnabled = checked}
                        />    
                        <SelectField
                            id="selectStatus"
                            menuItems={
                                [
                                    {
                                        label: "Approved",
                                        value: AccountStatus.approved
                                    },
                                    {
                                        label: "Requires Attention",
                                        value: AccountStatus.PendingAdminApproval
                                    
                                    }
                                ]
                            }
                            onChange={this.props.model.onStatusSelected}
                            placeholder="Select Status"
                            disabled={!this.props.model.selectStatusEnabled}
                        />
                    </div>
                </div>

            }
            </DialogContainer>
        );
    }
}
export default BulkEditUsers;


// WEBPACK FOOTER //
// ./src/component/BulkEditUsers/BulkEditUsers.tsx